<template>
    <!--- Navigation --->
    <nav class="section__navigation navigation pfull__12">
        <div class="horizontal-line" style="gap: 7px">

            <UnitsFilterXTypesDropdownButton v-if="$isPrometheus"/>

            <div class="filter-search filter-search_has-filter mr__8 "
                 :class="{'filter-search_active': FilterSearchValue>'','filter-search_focus': FilterSearchFocusin}"
            >
                <UnitsFilterDropdownButton />

                <ul class="filter-search__choice">
                    <li class="filter-search__choice-item"
                        v-for="chip in filterChips" :key="chip.key"
                        @click="chip.onClick"
                    >
                        {{ chip.text }}
                    </li>
                </ul>
                <input class="filter-search__input" type="text" :placeholder="$t('text.Search')" v-model.trim="FilterSearchValue" @focus="FilterSearchFocusin=true" @blur="FilterSearchFocusin=false">
                <button class="filter-search__close button button_view_icon button_theme_primary" @click="FilterSearchValue=''">
                    <span class="icon"> <span class="icon__symbol"><SvgIcon class="icon" name="common__close_sm" /></span> </span>
                </button>
            </div>

            <div class="navigation__button-group">
                <button class="button button_view_icon button_theme_base mtb__-4" data-type="open-drop-menu">
                    <span class="icon"> <span class="icon__symbol"><SvgIcon class="icon" name="common__more_vertical" /></span> </span>
                </button>
                <div class="navigation__dropdown-menu dropdown-menu position_right-bottom" data-type="" >
                    <div class="dropdown-menu__wrap">
                        <ul class="dropdown-menu__list">
                            <li class="dropdown-menu__item item" v-show="!isAllUnitsShowOnMap" @click="setUnitsFilteredShowOnMap({showOnMap: true})" v-if="false">
                                <span class="dropdown-menu__icon icon">
                                    <span class="icon__symbol"><SvgIcon class="icon" name="common__show" /></span>
                                </span>
                                <span class="dropdown-menu__item-name">{{ $t('menu.Show all filtered objects on map') }}</span>
                            </li>
                            <li class="dropdown-menu__item item" v-show="isAllUnitsShowOnMap" @click="setUnitsFilteredShowOnMap({showOnMap: false})" v-if="false">
                                <span class="dropdown-menu__icon icon">
                                    <span class="icon__symbol"><SvgIcon class="icon" name="common__show_disabled" /></span>
                                </span>
                                <span class="dropdown-menu__item-name">{{ $t('menu.Hide all filtered objects on map') }}</span>
                            </li>
                            <li class="dropdown-menu__item item" @click="_setUnitsShowOnMapByRoute()">
                                <span class="dropdown-menu__icon icon">
                                    <span class="icon__symbol">
                                        <SvgIcon class="icon" :name="showUnitsOnMap ? 'common__show' : 'common__show_disabled'" />
                                    </span>
                                </span>
                                <span class="dropdown-menu__item-name">{{ showUnitsOnMap ? $t('menu.Show all objects on map') : $t('menu.Hide all objects on map') }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import debounce from "lodash/debounce";
    import UnitsFilterDropdownButton from "@/components/units/dropdown/UnitsFilterDropdownButton";
    import UnitsFilterXTypesDropdownButton from "@/components/units/dropdown/UnitsFilterXTypesDropdownButton";

    export default {
        name: "UnitsList_navigation",
        mixins: [],
        inject: ['filteredUnitsIds'],
        props: {},
        components: {
            UnitsFilterXTypesDropdownButton,
            UnitsFilterDropdownButton
        },
        data() {
            return {
                FilterSearchFocusin: false,
                debounceUpdateSearchFilter: null,
            }
        },
        computed: {
            ...mapGetters([
                "getSubUnitsIdsByIds",
                "getUnitsOnMap",
                "showFilterDropdownMenu",
                "getAppUser",
                "getUnitOrFirstActiveUnitId",
                "getUserStorageKey",
                "getUnitsTypes",
                "getUnits",
            ]),
            isAll(){
                return !this.routeQueryFilter.signal
                    && !this.routeQueryFilter.movement
                    && !this.routeQueryFilter.type
                    && !this.routeQueryFilter.camera
            },
            filterTypes() {
                return this.getUnitsTypes?.filter(t => t.filterByTypes)
            },
            showUnitsOnMap() {
                return ![this.$consts.routerNames.units.all.main, this.$consts.routerNames.units.all.info].includes(this.routeName)
            },
            isAllUnitsShowOnMap() {
                let ids = this.filteredUnitsIds.filter(id => {
                    return !this.getUnitsOnMap.includes(id)
                })
                return ids.length === 0
            },
            FilterSearchSignalText() {
                let signal = this.$consts.FilterSearchLists.Units.signals.find(s => {
                    return s.id === this.routeQueryFilter.signal
                })
                return (signal)? this.$t(signal.translate) : ''
            },
            FilterSearchMovementText() {
                let movement = this.$consts.FilterSearchLists.Units.movements.find(s => {
                    return s.id === this.routeQueryFilter.movement
                })
                return (movement)? this.$t(movement.translate) : ''
            },
            FilterSearchTypeText() {
                let type = this.getUnitsTypes?.find(s => {
                    return s.id === this.routeQueryFilter.type
                })
                return (type) ? (this.$te('Unit.type.'+type.name) ? this.$t('Unit.type.'+type.name) : type.name) : ''
            },
            FilterSearchCameraText() {
                let type = this.$consts.FilterSearchLists.Units.camera.find(s => {
                    return s.id === this.routeQueryFilter.camera
                })
                return (type)? this.$t(type.translate) : ''
            },
            activeSearchValues() {
                let value = this.routeQueryFilter.search
                if (!value) return []
                return Array.isArray(value) ? value : [value]
            },
            filterChips() {
                let simpleChips = [
                    {key: 'signal', param: 'signal', text: this.FilterSearchSignalText},
                    {key: 'movement', param: 'movement', text: this.FilterSearchMovementText},
                    {key: 'type', param: 'type', text: this.FilterSearchTypeText},
                    {key: 'camera', param: 'camera', text: this.FilterSearchCameraText},
                ]
                    .filter(chip => this.routeQueryFilter[chip.param])
                    .map(chip => ({key: chip.key, text: chip.text, onClick: () => this.setUnitsQueryFilterParam(chip.param, false)}))

                let searchChips = [
                    {value: 'name', labelKey: 'Units.other.Name'},
                    {value: 'imei', labelKey: 'Units.other.IMEI'},
                    {value: 'cameraId', labelKey: 'Units.other.Camera ID'},
                    {value: 'dms', labelKey: 'Units.other.DMS'},
                    {value: 'cameraType', labelKey: 'Units.other.Camera Type'},
                    {value: 'deviceType', labelKey: 'Units.other.Device Type'},
                ]
                    .filter(chip => this.activeSearchValues.includes(chip.value))
                    .map(chip => ({key: 'search-' + chip.value, text: this.$t(chip.labelKey), onClick: () => this.toggleSearchFilterParam(chip.value)}))

                return [...simpleChips, ...searchChips]
            },
            FilterSearchValue: {
                get(){
                    // console.log('FilterSearchValue.get', this.filter.name)
                    return this.routeQueryFilter.name
                },
                set(value){
                    this.debounceUpdateSearchFilter(value)
                },
            },
        },
        methods: {
            ...mapActions([
                "setMapBoundsByUnits",
                "setUnitsShowOnMap",
            ]),
            ...mapMutations([
                "switchShowFilterDropdownMenu",
                "setShowFilterDropdownMenu",
                "setAllUnitsShowOnMap",
            ]),
            updateSearchFilter(value) {
                let filter = {...this.routeQueryFilter}
                filter.name = value
                this.setRoute.unitsFilter(this.$route, this.$router, filter)
            },
            setUnitsQueryFilterParam(param, value) {
                let filter = {...this.routeQueryFilter}
                filter[param] = value
                if(!value) delete filter[param];
                this.setRoute.unitsFilter(this.$route, this.$router, filter)
            },
            toggleSearchFilterParam(value) {
                let nextValues = this.activeSearchValues.includes(value)
                    ? this.activeSearchValues.filter(v => v !== value)
                    : [...this.activeSearchValues, value]

                let filter = {...this.routeQueryFilter}
                if (nextValues.length) {
                    filter.search = nextValues
                } else {
                    delete filter.search
                }
                this.setRoute.unitsFilter(this.$route, this.$router, filter)
            },
            resetUnitsFilter() {
                this.setRoute.unitsFilter(this.$route, this.$router, null);
            },
            setUnitsFilteredShowOnMap(args){//{showOnMap: true, unitIds: filteredUnitsIds}
                args = {...args, unitIds: this.filteredUnitsIds}
                this.setUnitsShowOnMap(args)
                if(args.showOnMap) {
                    this.setMapBoundsByUnits(args.unitIds)
                }
            },
            _setUnitsShowOnMapByRoute(){
                let unitIds = this.getUnits.map(u => u.id)
                if(this.showUnitsOnMap) {
                    this.setRoute.unitsAll(this.$route, this.$router)
                } else {
                    let unitId = localStorage.getItem(this.getUserStorageKey+'.unit.active')
                    unitId = this.getUnitOrFirstActiveUnitId(unitId)
                    this.setRoute.unitId(this.$route, this.$router, unitId)
                    unitIds = [unitId]
                }
                this.setAllUnitsShowOnMap(unitIds)
                this.setMapBoundsByUnits(unitIds)
            }
        },
        updated() {
            //console.log(`UnitsList_navigation updated`)
        },
        mounted() {
            this.debounceUpdateSearchFilter = debounce((value) => this.updateSearchFilter(value), 500)
        },
    }
</script>

<style scoped>

</style>